import { render, staticRenderFns } from "./anime-detail.vue?vue&type=template&id=a9df1dd6&scoped=true&"
import script from "./anime-detail.vue?vue&type=script&lang=js&"
export * from "./anime-detail.vue?vue&type=script&lang=js&"
import style0 from "./anime-detail.vue?vue&type=style&index=0&id=a9df1dd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9df1dd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/magonxesp/repos/RandomAnimePicker/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a9df1dd6')) {
      api.createRecord('a9df1dd6', component.options)
    } else {
      api.reload('a9df1dd6', component.options)
    }
    module.hot.accept("./anime-detail.vue?vue&type=template&id=a9df1dd6&scoped=true&", function () {
      api.rerender('a9df1dd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/anime/anime-detail.vue"
export default component.exports